import React from 'react';
import authService from '../../services/auth/service-auth';
import { useAppDispatch } from '../../ducks/hooks';
import loggerService from '../../services/logging/service-logger';
import { setLoggedUser } from '../../ducks/impersonation/duck-impersonation';
import { useTrackException } from '../../services/logging/hooks';
import { MSX_AUTH_NOT_FOUND } from '../../services/auth/service-auth-msx';
import { useFCPMarker } from '../../services/performance-observer/hooks';
import { LoadingPlaceholder } from '../../shared-components/hoc-loading-placeholder';

export const AadProvider = (props: React.PropsWithChildren) => {
  const { children } = props;
  const dispatch = useAppDispatch();
  const trackException = useTrackException();
  const [authUser, setAuthUser] = React.useState<string>('');

  useFCPMarker();
  React.useEffect(() => {
    const handleLogin = async () => {
      try {
        const user = await authService.getLoggedAccountInfo();
        if (user) {
          loggerService.setUserContext(user);
          setAuthUser(user.split('@')[0]);
        } else {
          throw new Error('User information not available');
        }
      } catch (error: any) {
        if (error.message === MSX_AUTH_NOT_FOUND && !authService.haveFallbacked) {
          authService
            .fallbackToMemAuthService()
            .then(async () => {
              await handleLogin();
            })
            .catch((e: any) => {
              trackException(e.message, 'Seller Experience', 'AAD Provider');
            });
          setAuthUser('');
        } else {
          trackException(error.message, 'Seller Experience', 'AAD Provider');
        }
      }
    };
    void handleLogin();
  }, [trackException]);

  React.useEffect(() => {
    if (!authUser) return;
    dispatch(setLoggedUser(authUser));
  }, [authUser, dispatch]);

  return (
    <LoadingPlaceholder isLoading={!authUser} includeStandaloneHeader>
      {<>{children as React.ReactElement<any>}</>}
    </LoadingPlaceholder>
  );
};
